import * as React from 'react';
import cn from 'classnames';

import { TagType } from 'shared/newEntities/components/Tag';

import './PhotoCornerDot.modules.scss';

type Props = {
  type: TagType.success | TagType.warning | TagType.neutral;
  className?: string;
};

const PhotoCornerDot: React.FC<Props> = ({ type, className }: Props) => {
  return (
    <div
      styleName={cn('photo-corner-dot', `photo-corner-dot_${type}`)}
      className={className}
    />
  );
};

export default React.memo(PhotoCornerDot);
